import { Component } from "react";
import { connect } from "react-redux";
import { hasReadAccess } from "../../../state/user/selectors";

class HasReadPrivileges extends Component {
  render() {
    const { children, hasReadAccess } = this.props;
    return hasReadAccess ? children : null;
  }
}

const mapStateToProps = (state) => ({
  hasReadAccess: hasReadAccess(state),
});

export default connect(mapStateToProps)(HasReadPrivileges);
